/* eslint-disable */
import React from 'react';

const FaqIcon = ({ filled }) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 0C4.48625 0 0 4.48625 0 10C0 15.5138 4.48625 20 10 20C15.5138 20 20 15.5138 20 10C20 4.48625 15.5138 0 10 0ZM10.1783 14.3636C9.53936 14.3636 9.0214 14.8816
               9.0214 15.5205C9.0214 16.1594 9.53936 16.6774 10.1783 16.6774C10.8172 16.6774 11.3352 16.1594 11.3352 15.5205C11.3352 14.8816 10.8172 14.3636 10.1783
               14.3636ZM6.81071 7.43425C6.81071 5.57721 8.32094 4.06698 10.178 4.06698C12.035 4.06698 13.5453 5.57721 13.5453 7.43425C13.5453 9.04657 12.4074 10.3965 10.8928
               10.7252V12.7392C10.8928 13.1338 10.5726 13.454 10.178 13.454C9.78334 13.454 9.46318 13.1338 9.46318 12.7392V10.0867C9.46318 9.69207 9.78334 9.37192 10.178
               9.37192C11.2462 9.37192 12.1157 8.50244 12.1157 7.43425C12.1157 6.36607 11.2462 5.49659 10.178 5.49659C9.1098 5.49659 8.24032 6.36607 8.24032 7.43425C8.24032 7.8289
               7.92017 8.14906 7.52552 8.14906C7.13086 8.14906 6.81071 7.8289 6.81071 7.43425Z"
            fill={filled ? '#05C3DE' : 'white'}
        />
    </svg>
);

export default FaqIcon;
